<div [ngStyle]="{ height: '95vh' }" style="background: #f5f5f5; display: flex; flex-direction: column">
  <mat-toolbar>
    <mat-toolbar-row style="padding-left: 0; background-color: white">
      <button
        aria-label="Close"
        mat-dialog-close
        mat-flat-button
        style="padding-left: 5px; padding-right: 5px; background-color: white"
        tabindex="-1"
      >
        <mat-icon aria-hidden="true" class="dialog-close-icon">close</mat-icon>
      </button>
      <span [ngStyle]="{ 'margin-left': 0 }"> </span>
      <mat-divider style="height: 50%; margin-left: 10px; margin-right: 10px" vertical></mat-divider>
      <span [ngStyle]="{ 'margin-left': 20 }">
        {{ data().locationName }}
        ({{ data().branchName }}) on
        {{ data().time }}
      </span>

      <div>
        <mat-menu #appMenu="matMenu" xPosition="before">
          @if (data().status !== MnpEventStatusEnum.Theft) {
            <button (click)="handleStatusChange(MnpEventStatusEnum.Theft)" mat-menu-item>Theft</button>
          }
          @if (data().status !== MnpEventStatusEnum.NotTheft) {
            <button (click)="handleStatusChange(MnpEventStatusEnum.NotTheft)" mat-menu-item>No theft</button>
          }
          @if (data().status !== MnpEventStatusEnum.OperationalIssue) {
            <button (click)="handleStatusChange(MnpEventStatusEnum.OperationalIssue)" mat-menu-item>Operational Issue</button>
          }
          @if (data().status !== MnpEventStatusEnum.Unknown) {
            <button (click)="handleStatusChange(MnpEventStatusEnum.Unknown)" mat-menu-item>Unknown</button>
          }
        </mat-menu>
        <button [matMenuTriggerFor]="appMenu" [class.spinner]="isUpdatingStatus" mat-stroked-button matTooltip="">
          {{ statusLabel }}
          @if (statusLabel !== "Click to review") {
            <mat-icon aria-hidden="true">expand_more</mat-icon>
          }
        </button>
      </div>

      <mat-divider style="height: 50%; margin-left: 10px; margin-right: 10px" vertical></mat-divider>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="container" style="background-color: #f5f5f5">
    <mat-tab-group [dynamicHeight]="true" mat-stretch-tabs selectedIndex="0">
      <mat-tab label="Video">
        <table class="live-streams">
          <tr>
            <th>Camera name</th>
            <th>Rhombus link</th>
          </tr>
          <tr>
            <td>{{ data().cameraName }}</td>
            <td>
              <a href="{{ data().rhombusLink }}" target="_blank">{{ data().rhombusLink }}</a>
            </td>
          </tr>
        </table>
      </mat-tab>
      <!-- <mat-tab label="Timeline"> </mat-tab> -->
      <mat-tab label="Comments">
        <app-movement-no-purchase-comments [eventId]="data().id" [comments]="data().comments"></app-movement-no-purchase-comments>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
